export const phone = (value: string): boolean => {
  const regexQuery = '^\\+?\\d{11,}$'
  const phone = new RegExp(regexQuery, 'i')
  return phone.test(value)
}

export const accepted = (value: any): boolean => {
  return value === true
}
